module.exports = __webpack_public_path__ + "img/arts-club.68161c54.png";